// Banner'ın hangi vitrine düştüğü tek yerden okunur.
//
// `/sliders` yanıtı **bütün** banner'ları döndürür; hangisinin nerede
// çizileceğini `placement` söyler (backend: `models.SliderPlacement`). Süzgeç
// kabuk başına kopyalandığı için bir süre yalnızca klasik ana sayfa ile
// HeroSlider süzüyordu; Merit/Zümrüt/Paris/Vega/Herkül kabukları listeyi
// olduğu gibi çizdiği için "Yan Banner" olarak işaretlenen görsel o
// şemalarda ana slider'a da düşüyordu. Katalog sayfası banner'ları
// eklendiğinde aynı sızıntı slot banner'ını beş ana sayfaya taşırdı — bu
// yüzden süzgeç artık ortak.
//
// İlgili: components/PageSlider.jsx, components/HeroSlider.jsx.

export const DEFAULT_PLACEMENT = 'main';

// Kolonun varsayılanı 'main'; alanı hiç yazılmamış eski kayıtlar da ana
// slider'a aittir.
export const placementOf = (slide) => (
  (slide && slide.placement) || DEFAULT_PLACEMENT
);

export const slidersAt = (slides, placement = DEFAULT_PLACEMENT) => (
  (Array.isArray(slides) ? slides : []).filter(
    (slide) => placementOf(slide) === placement,
  )
);

export default slidersAt;
